import { breakpointQueries as i } from "./index38.mjs";
const a = () => ({
  isXS: window.matchMedia(i.isXS).matches,
  isSM: window.matchMedia(i.isSM).matches,
  isMD: window.matchMedia(i.isMD).matches,
  isLG: window.matchMedia(i.isLG).matches,
  isXL: window.matchMedia(i.isXL).matches,
  is2XL: window.matchMedia(i.is2XL).matches
});
export {
  a as getCurrentBreakpoints
};
